import { render, staticRenderFns } from "./FaqsBox.vue?vue&type=template&id=7d6ccc56&scoped=true"
import script from "./FaqsBox.vue?vue&type=script&lang=js"
export * from "./FaqsBox.vue?vue&type=script&lang=js"
import style0 from "./FaqsBox.vue?vue&type=style&index=0&id=7d6ccc56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6ccc56",
  null
  
)

export default component.exports